import propTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { addFeedback } from '../../actions/feedback';
import FeedbackPopup from './FeedbackPopup';


const Feedback = ({
    auth, addFeedback
}) => {

    const [formData, setFormData] = useState({
        name: '',
        feedbacktext: '',
        stars: '',
        email: ''
    });

    const {
        name,
        feedbacktext,
        stars,
        email
    } = formData;

    const clearForm = (e) =>
        setFormData({
            name: '',
            feedbacktext: '',
            stars: '',
            email: ''
        }
    );

    const [isOpen, setIsOpen] = useState(false);
    const togglePopup = () => {
        setIsOpen(!isOpen);
        clearForm();
    };

    const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = (e) => {
        e.preventDefault();
        addFeedback(formData);
        togglePopup();
        clearForm();
    };

return (
    <>
        <div className='feedback' >
            <div className='btn btn-warning' onClick={togglePopup} >
                <i className='fa fa-comments'/> Feedback
            </div>
        </div>
        {isOpen && <FeedbackPopup
            content={
                <Card border='warning'>
                    <Card.Header>
                        <Row>
                        <Col><i className='fa fa-comments'/> Feedback</Col>
                        <Col><div className="feedback-close-icon" onClick={togglePopup} style={{float:'right'}}><b>X</b></div></Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        <form style={{ textAlign: "center" }} className="form" onSubmit={ e => onSubmit(e)}>
                            <input type='text' placeholder='Name' name="name" value={name} required onChange={e => onChange(e)} />
                            <br />
                            <input type='text' placeholder='Email' name="email" value={email} required onChange={e => onChange(e)} />
                            <br />
                            <input type='text' placeholder='Write to us...' name="feedbacktext" value={feedbacktext} required onChange={e => onChange(e)} />
                            <br />
                            <Row>
                                <Col style={{maxWidth: '110px'}}>
                                    <select id="stars" name='stars' value={stars} size="1" onChange={e => onChange(e)} style={{textAlign: 'center'}}>
                                        <option value="" disabled selected>Rating</option>
                                        <option value={1}>&#128544;</option>
                                        <option value={2}>&#128528;</option>
                                        <option value={3}>&#128578;</option>
                                        <option value={4}>&#128515;</option>
                                        <option value={5}>&#128151;</option>
                                    </select>
                                </Col>
                                <Col>
                                    <input type="submit" className="btn btn-warning" value="Send" style={{float: 'right'}}/> 
                                </Col>
                            </Row>
                        </form>
                    </Card.Body>
                </Card>
                }
            handleClose={togglePopup}
            />
        }
    </>
)};

Feedback.propTypes = {
    auth: propTypes.object.isRequired,
    addFeedback: propTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {addFeedback })(
    Feedback
);
